import { memo } from "react";

export const TARGET = {
  BLANK: "_blank",
  SELF: "_self",
  PARENT: "_parent",
  TOP: "_top",
};

export const TILESROUTE = Object.freeze({
  collectionRoute: "collection",
  productRoute: "product",
  lookAndFeel: "look_and_feel",
  color: "color",
  location: "location",
  collection: "collection",
});

export const formatTitle = (title = "") => {
  if (title?.includes("-")) {
    return title
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("-");
  } else {
    return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
  }
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export function stripHtmlTags(input, maxLength = Infinity) {
  if (typeof input !== "string") return "";
  const plainText = input.replace(/<[^>]*>/g, "").trim();
  return plainText.length > maxLength
    ? plainText.slice(0, maxLength) + "..."
    : plainText;
}

export const SafeHTML = memo(function SafeHTML({ html, className = "" }) {
  if (!html) return null;
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
  );
});

export const generateBreadcrumbSchema = (
  breadcrumbData = [],
  currentUrl = null
) => {
  const baseUrl = "https://www.simpolo.com";

  const hasHome =
    breadcrumbData.length > 0 &&
    breadcrumbData[0]?.title?.toLowerCase() === "home";

  const finalBreadcrumbData = hasHome
    ? breadcrumbData
    : [{ title: "Home", link: "/" }, ...breadcrumbData];

  const itemsListArr = finalBreadcrumbData.map((item, index) => {
    const listItem = {
      "@type": "ListItem",
      position: index + 1,
      name: item?.title,
    };

    if (item.link) {
      listItem.item = `${baseUrl}${item?.link}`;
    } else if (index === finalBreadcrumbData.length - 1 && currentUrl) {
      listItem.item = `${baseUrl}${currentUrl}`;
    }
    return listItem;
  });

  return {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: itemsListArr,
  };
};
